import { render, staticRenderFns } from "./ContrattoSperimentazionePagamento.vue?vue&type=template&id=621839c6&"
import script from "./ContrattoSperimentazionePagamento.vue?vue&type=script&lang=js&"
export * from "./ContrattoSperimentazionePagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports